import React from "react";
import { Grid, Button, Typography, Paper } from "@mui/material";

const AvailabilityGrid = ({ slots, onChange, disabled }) => {
    const handleToggle = (index) => {
        if (disabled) return;
        const newSlots = [...slots];
        newSlots[index] = { ...newSlots[index], available: !newSlots[index].available };
        onChange(newSlots);
    };

    return (
        <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="subtitle2" gutterBottom>Select Available Time Slots (9:00 - 17:00)</Typography>
            <Grid container spacing={1}>
                {slots.map((slot, index) => (
                    <Grid item xs={6} sm={4} md={3} key={index}>
                        <Button
                            variant={slot.available ? "contained" : "outlined"}
                            color={slot.available ? "success" : "inherit"}
                            fullWidth
                            onClick={() => handleToggle(index)}
                            disabled={disabled}
                            sx={{ 
                                opacity: disabled ? 0.5 : 1,
                                height: 50
                            }}
                        >
                            {slot.start} - {slot.end}
                        </Button>
                    </Grid>
                ))}
            </Grid>
        </Paper>
    );
};

export default AvailabilityGrid;
